// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2RVa4","itemTitle":"ClientEmergencyInfo_itemTitle__1GVog","itemText":"ClientEmergencyInfo_itemText__1IjXk"};